import styled, { css } from 'styled-components';

import { FontSize } from '../Input/types';

const StyledWrapper = styled.div<{
  isHover: boolean;
  isFocus: boolean;
  sizeType: SizeType;
}>`
  position: relative;
  width: 100%;
  background-color: transparent;

  .right-icon {
    transition: all 0.2s;
    cursor: pointer;
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);

    font-size: ${({ sizeType }) => `${FontSize[sizeType]}px`};
    color: ${({ theme }) => theme.colors.gray600};

    ${({ isHover }) =>
      isHover &&
      css`
        color: ${({ theme }) => theme.colors.gray600};
      `}

    ${({ isFocus }) =>
      isFocus &&
      css`
        color: ${({ theme }) => theme.colors.gray800};
      `}
  }
`;

const PasswordInputStyle = {
  StyledWrapper,
};

export default PasswordInputStyle;
